<div class="thread-status-container"
     *ngIf="isVisible"
     [ngClass]="statusStateClass"
     [style.--status-color]="statusColor"
     [attr.data-loading]="loading">
  <div class="status-line">
    <div class="status-info">
      <span class="status-loader" *ngIf="shouldShowSubtleLoader" aria-hidden="true">
        <span class="status-loader__dot"></span>
        <span class="status-loader__dot"></span>
        <span class="status-loader__dot"></span>
      </span>
      <i [class]="statusIcon" class="status-icon" *ngIf="!shouldShowSubtleLoader && statusIcon"></i>
      <span class="status-text">{{ statusText }}</span>
    </div>
  </div>

  <div class="sassy-indicators-container" *ngIf="shouldShowSassyIndicators && currentSassyDisplayText">
    <div class="sassy-indicators">
      <span class="sassy-text">{{ currentSassyDisplayText }}</span>
      <span class="typing-cursor">|</span>
    </div>
  </div>
</div>
